import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { SUPPORTED_LANGUAGES, applyLanguageDirection } from '@/i18n';

export default function LanguageSelector({ compact = false }) {
  const { i18n } = useTranslation();

  const handleChange = (value) => {
    i18n.changeLanguage(value);
    applyLanguageDirection(value);
    localStorage.setItem('qn_language', value);
  };

  const currentLang = SUPPORTED_LANGUAGES.find(l => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  return (
    <div className="flex items-center gap-2" data-testid="language-selector">
      <Globe className="w-4 h-4 text-[var(--qn-foreground-subtle)] shrink-0" />
      <Select value={i18n.language} onValueChange={handleChange}>
        <SelectTrigger 
          className={`bg-transparent border-[var(--qn-border)] text-sm ${compact ? 'w-[100px] h-8' : 'w-[160px]'}`}
          data-testid="language-selector-trigger"
          data-automation-id="language-selector"
        >
          <SelectValue>{compact ? currentLang.code.toUpperCase() : currentLang.nativeName}</SelectValue>
        </SelectTrigger>
        <SelectContent className="bg-[var(--qn-card)] border-[var(--qn-border)] max-h-[300px]">
          {SUPPORTED_LANGUAGES.map((lang) => (
            <SelectItem
              key={lang.code}
              value={lang.code}
              className="text-sm cursor-pointer"
              data-testid={`lang-option-${lang.code}`}
            >
              <span className="flex items-center gap-2">
                <span className="text-xs text-[var(--qn-foreground-subtle)] w-6">{lang.code.toUpperCase()}</span>
                <span>{lang.nativeName}</span>
                {lang.dir === 'rtl' && (
                  <span className="text-xs text-[var(--qn-foreground-subtle)] ml-1">(RTL)</span>
                )}
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
